import axios from "../../modules/Shared/auth-header";
import { toast } from "react-toastify";
import $ from "jquery";
import AuthService from "../../modules/Auth/AuthService";
import PermissionFeature from "../../modules/Permissions/PermissionFeature";

export default {
  GetEmailList: async () => {
    let url = `/api/Email/EmailList`;
    var { data } = await axios.get(url);
    if (data.statusCode == 200) {
      return data.result;
    } else {
      toast.error("Invalid Request");
      return null;
    }
  },
  LoadTeams: async () => {
    let url = `/api/Email/AuthorizedSenderTeams`;
    var { data } = await axios.get(url);
    if (data.statusCode == 200) {
      return data.result;
    } else {
      toast.error("Invalid Request");
      return null;
    }
  },
  RemoveAddlRecipient: async (requestBody) => {
    $(".loading").show();
    let url = `/api/MailGun/DeleteAdditionalRecipient`;
    var { data } = await axios
      .delete(url, { data: requestBody })
      .catch((ex) => {
        console.log(ex);
        $(".loading").hide();
      });
    if (data.statusCode == 200) {
      $(".loading").hide();
      toast.success(data.message);
      return data;
    } else {
      toast.error("Something went Wrong!");
      $(".loading").hide();
      return null;
    }
  },
  RemoveAuthSender: async (id) => {
    $(".loading").show();
    let url = `/api/Email/DeleteAuthorizedSender/${id}`;
    var { data } = await axios.delete(url).catch((ex) => {
      console.log(ex);
      $(".loading").hide();
    });
    if (data.statusCode == 200) {
      $(".loading").hide();
      toast.success(data.message);
      return data.result;
    } else {
      toast.error("Something went Wrong!");
      $(".loading").hide();
      return null;
    }
  },
  updateSubscriberList: async (params) => {
    let url = `/api/MailGun/GetListMembersPage`;

    return await axios
      .post(url, {
        listAddress: params.mgListAddress,
        subscriberType: params.subscribersTablesTypes,
      })
      .catch((ex) => {
        console.log(ex);
      });
  },
  getAdditionalSubsribersEmailAddresses: async (params) => {
    let url = `/api/MailGun/GetAdditionalSubsribersEmailAddresses`;

    return await axios
      .post(url, {
        listAddress: params.mgListAddress,
        subscriberType: params.subscribersTablesTypes,
      })
      .catch((ex) => {
        console.log(ex);
      });
  },
  updateUnsubscriberList: (params) => {
    let url = `/api/MailGun/GetListMembersPage`;
    return axios
      .post(url, {
        listAddress: params.mgListAddress,
        subscriberType: params.unSubscribersTablesTypes,
      })
      .catch((ex) => {
        console.log(ex);
      });
  },
  DeleteFRTEmailList: async (id) => {
    $(".loading").show();
    let url = `/api/FacilityRegionEmail/DeleteEmailList?emailListId=${id}`;
    return await axios.delete(url).catch((ex) => {
      console.log(ex);
      toast.error("Something went wrong!");
      $(".loading").hide();
    });
  },
  DeleteSSEmailList: async (id) => {
    $(".loading").show();
    let url = `/api/SavedSearchEmailList/DeleteEmailList?emailListId=${id}`;
    return await axios.delete(url).catch((ex) => {
      console.log(ex);
      toast.error("Something went wrong!");
      $(".loading").hide();
    });
  },
  GetEmailPriviliges: async () => {
    let url = `/api/SavedSearchEmailList/GetEmailPriviliges`;
    return await axios.get(url);
  },
  GetDomainName: async () => {
    let url = `/api/SavedSearchEmailList/GetDomainName`;
    return await axios.get(url);
  },
  GetSavedSearchDetail: async (id) => {
    let url = `/api/SavedSearchEmailList/GetSavedSearchDetail?savedSearchId=${id}`;
    return await axios.get(url);
  },
  GetMailingListMemberCount: async (address) => {
    let url = `/api/MailGun/GetMailingListTotalCount?mailListAddress=${address}`;
    return await axios.get(url);
  },
  GetRegistrantsEmailList: async (id) => {
    let url = `/api/SavedSearchEmailList/GetRegistrantsEmailList?registrationId=${id}`;
    return await axios.get(url);
  },
  canView: () => {
    return AuthService.canView(PermissionFeature.EmailListsLists);
  },
  canAdd: () => {
    return AuthService.canAdd(PermissionFeature.EmailListsLists);
  },
  canUpdate: () => {
    return AuthService.canUpdate(PermissionFeature.EmailListsLists);
  },
  canDeleteEmailList: () => {
    return AuthService.canDelete(PermissionFeature.EmailListsLists);
  },
  shouldHideActionIcons: () => {
    let view = AuthService.canView(PermissionFeature.EmailListsLists);
    let update = AuthService.canUpdate(PermissionFeature.EmailListsLists);
    let result = false;
    //console.log("update", update);
    //console.log("view", view);
    if (view && !update) {
      // Just View Permission,has not update permission.
      result = false; // Hide the Action Icons for prohibiting the user to trigger any save changes.
    } else {
      result = true;
    }
    //console.log("hide icon", result);
    return result;
  },
  ///Thinking about using it in redux actions
  // SaveAuthSenders: () => {
  //   this.showSpinner();
  //   let id =
  //     this.props.isTeam == true ? this.props.TeamId : this.props.FacilityId;

  //   let authSenders = [
  //     ...this.props.melstate.authorizedSendersMembers,
  //     ...this.props.melstate.authorizedSendersTeams,
  //   ];

  //   let emailListAdditionalRecpts = [
  //     ...this.props.melstate.additionalRecipientsMembers,
  //     ...this.props.melstate.additionalRecipientsTeams,
  //   ];

  //   let emailConfigData = {
  //     authSenders,
  //     emailListAdditionalRecpts,
  //   };

  //   if (this.state.emailAlias === this.state.emailAliasOld) {
  //     let url = `/api/FacilityRegionEmail/UpdateEmailPrivilege?id=${id}&accessLevel=${this.state.selectedPrivilige}&reply_preference=${this.state.reply_preference}&name=${this.state.name}`;
  //     axios.post(url, emailConfigData).then(({ data }) => {
  //       if (data.status && data.status.toLowerCase() == "success") {
  //         this.hideSpinner();
  //         toast.success(data.message);
  //       } else {
  //         this.hideSpinner();
  //         toast.error(data.message);
  //       }
  //     });
  //   } else {
  //     let url = `/api/FacilityRegionEmail/RecreateEmail?id=${id}&emailAlias=${this.state.emailAlias}&accessLevel=${this.state.selectedPrivilige}&reply_preference=${this.state.reply_preference}`;
  //     axios.post(url).then(({ data }) => {
  //       if (data.status && data.status.toLowerCase() == "success") {
  //         this.hideSpinner();
  //         toast.success(data.message);
  //         this.setState({ emailAliasOld: this.state.emailAlias });
  //       } else {
  //         this.hideSpinner();
  //         toast.error(data.message);
  //       }
  //     });
  //   }
  // },
};
